import {SET_PROMOTIONS} from "./PromotionsTypes";

export function promotionsReducer(state = [], action) {
    switch (action.type) {
        case SET_PROMOTIONS :
            if (!Array.isArray(action.data)) return [];
            return action.data;
        default:
            return state;
    }
}
